import request from '@/utils/request'

// 查询分类列表
export function listClassification(query) {
  return request({
    url: '/project/classification/list',
    method: 'get',
    params: query
  })
}

// 查询分类详细
export function getClassification(id) {
  return request({
    url: '/project/classification/' + id,
    method: 'get'
  })
}

// 新增分类
export function addClassification(data) {
  return request({
    url: '/project/classification',
    method: 'post',
    data: data
  })
}

// 修改分类
export function updateClassification(data) {
  return request({
    url: '/project/classification',
    method: 'put',
    data: data
  })
}

// 删除分类
export function delClassification(id) {
  return request({
    url: '/project/classification/' + id,
    method: 'delete'
  })
}
